<template>
  <div>
    <headerSection :mainMenu="mainMenu"></headerSection>

    <!-- Running Text Section -->
    <RunningText
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Main Layout Container -->
    <div class="main-layout">
      <!-- Desktop Layout -->
      <div class="desktop-layout desktop-only">
        <!-- Left Sidebar -->
        <LeftSidebar
          :leftMenuItems="leftMenuItems"
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Partner Cover Section -->
          <div class="x-cover x-index-event-container" style="padding-top: 0px;">
            <div class="container-fluid">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content">&nbsp;</div>
              </div>
            </div>
          </div>

          <!-- Main Menu Bar -->
          <MainMenuBar
            :mainMenuItems="mainMenuItems"
            :hoveredIndex="hoveredMainIndex"
            :user="user"
            @menu-enter="onMainMenuEnter"
            @menu-leave="onMainMenuLeave"
          />

          <!-- Partner Content -->
          <div class="content-wrapper">
            <div class="x-partner-container">
              <div class="container">
                <div class="row -partner-row-wrapper">
                  <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                    <fieldset class="form-group text-center mb-0 px-1">
                      <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                        <div class="col-sm-12 col-lg-12 col-12">
                          <h2 class="text-center mb-3" style="font-weight: 500;color:#fff;">ลิงก์รับทรัพย์</h2>
                          <img src="https://firebasestorage.googleapis.com/v0/b/phenixs789.firebasestorage.app/o/images%2F-Mz_m0Rf-hUPdBhEvbeI.png?alt=media&token=d9ec2625-fb1b-4d01-96de-c79ad720dd27" class="-cover-img img-fluid" style="padding-bottom:20px;">
                          <div role="group" class="input-group">
                            <input id="copyTarget3" type="text" readonly="readonly" class="form-size-14 form-control" :value="`https://phenix789.co/register?ref=${user.code}`">
                            <div class="input-group-append">
                              <button id="copyButton3" class="btn btn-copy-link btn-sm btn_bg" v-clipboard:copy="`https://phenix789.co/register?ref=${user.code}`" v-clipboard:success="clipboardSuccessHandler"><i class="fa fa-copy fa-sm mr-1"></i>คัดลอก </button>
                            </div>
                          </div>
                          <p class="text-white mt-4 mb-0" style="font-family: Kanit;"> ส่ง Link ได้ทุกช่องทางรับทรัพย์กับเรา </p>
                        </div>
                      </div>
                    </fieldset>

                    <div class="text-title text-center" style="font-family: Kanit;">รายได้ผู้แนะนำ</div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">แนะนำเพื่อน</p>
                          <p class="mb-0">{{(this.level1)?Object.keys(this.level1).length:0}}</p>
                          <img src="../assets/images/analysis.png" width="30" style="cursor:pointer" @click="showlevel(1)">
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">เพื่อนแนะนำเพื่อน</p>
                          <p class="mb-0">{{(this.level2)?Object.keys(this.level2).length:0}}</p>
                          <img src="../assets/images/analysis.png" width="30" style="cursor:pointer" @click="showlevel(2)">
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">รายได้แนะนำเพื่อน</p>
                          <p class="mb-0">{{ (partner && partner.total1)?numberWithCommas(partner.total1):0}}</p>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">รายได้เพื่อนแนะนำเพื่อน</p>
                          <p class="mb-0">{{ (partner && partner.total2)?numberWithCommas(partner.total2):0}}</p>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">รายได้ทั้งหมด</p>
                          <p class="mb-0">{{ (partner && partner.total)?numberWithCommas(partner.total):0}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 text-center" style="padding-top:22px;">
                      <a href="javascript:void(0)" @click="movePartnerToWallet()" class="text-white js-account-approve-aware btn" :style="checkStyle()" data-toggle="modal">
                        <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โอนเงินเข้ากระเป๋าหลัก</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout mobile-only">
        <!-- Mobile Partner Cover Section -->
        <div class="x-cover x-index-event-container mobile-cover" >
          <div class="container-fluid">
            <div class="row -contents-wrapper">
              <div class="col-12 col-md-6 -left-content"></div>
              <div class="col-12 col-md-6 -right-content bg-mobile">
                <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                  <div class="slick-list draggable" style="height: 58px;">
                    <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                      <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                        <h1 class="-title">ลิงก์รับทรัพย์ <br> แชร์รับเงิน</h1>
                        <p class="-sub-title">ส่ง Link ได้ทุกช่องทางรับทรัพย์กับเรา</p>
                        <div class="-btn-wrapper d-none animated fadeInUp" data-animatable="fadeInUp" data-delay="500">
                          <a href="javascript:void(0)" class="btn -register-btn order-0" data-toggle="modal" data-target="#registerModal" tabindex="0">
                            <span class="-btn-title">สมัครสมาชิก</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Main Menu -->
        <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

        <!-- Mobile With Sidebar Layout -->
        <div class="mobile-with-sidebar">
          <!-- Mobile Left Sidebar -->
          <MobileLeftSidebar
            :leftMenuItems="leftMenuItems"
            :hoveredIndex="hoveredLeftIndex"
            :user="user"
            @menu-enter="onLeftMenuEnter"
            @menu-leave="onLeftMenuLeave"
          />

          <!-- Mobile Content Area -->
          <div class="mobile-content">
            <!-- Mobile Partner Content -->
            <div class="mobile-content-wrapper">
              <div class="x-partner-container">
                <div class="container">
                  <div class="row -partner-row-wrapper">
                    <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                      <fieldset class="form-group text-center mb-0 px-1">
                        <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                          <div class="col-sm-12 col-lg-12 col-12">
                            <h2 class="text-center mb-3" style="font-weight: 500;color:#fff;">ลิงก์รับทรัพย์</h2>
                            <img src="https://firebasestorage.googleapis.com/v0/b/phenixs789.firebasestorage.app/o/images%2F-Mz_m0Rf-hUPdBhEvbeI.png?alt=media&token=d9ec2625-fb1b-4d01-96de-c79ad720dd27" class="-cover-img img-fluid" style="padding-bottom:20px;">
                            <div role="group" class="input-group">
                              <input id="copyTarget3" type="text" readonly="readonly" class="form-size-14 form-control" :value="`https://phenix789.co/register?ref=${user.code}`">
                              <div class="input-group-append">
                                <button id="copyButton3" class="btn btn-copy-link btn-sm btn_bg" v-clipboard:copy="`https://phenix789.co/register?ref=${user.code}`" v-clipboard:success="clipboardSuccessHandler"><i class="fa fa-copy fa-sm mr-1"></i>คัดลอก </button>
                              </div>
                            </div>
                            <p class="text-white mt-4 mb-0" style="font-family: Kanit;"> ส่ง Link ได้ทุกช่องทางรับทรัพย์กับเรา </p>
                          </div>
                        </div>
                      </fieldset>

                      <div class="text-title text-center" style="font-family: Kanit;">รายได้ผู้แนะนำ</div>
                      <div class="row no-gutters">
                        <div class="col-6">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">แนะนำเพื่อน</p>
                            <p class="mb-0">{{(this.level1)?Object.keys(this.level1).length:0}}</p>
                            <img src="../assets/images/analysis.png" width="30" style="cursor:pointer" @click="showlevel(1)">
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">เพื่อนแนะนำเพื่อน</p>
                            <p class="mb-0">{{(this.level2)?Object.keys(this.level2).length:0}}</p>
                            <img src="../assets/images/analysis.png" width="30" style="cursor:pointer" @click="showlevel(2)">
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">รายได้แนะนำเพื่อน</p>
                            <p class="mb-0">{{ (partner && partner.total1)?numberWithCommas(partner.total1):0}}</p>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">รายได้เพื่อนแนะนำเพื่อน</p>
                            <p class="mb-0">{{ (partner && partner.total2)?numberWithCommas(partner.total2):0}}</p>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">รายได้ทั้งหมด</p>
                            <p class="mb-0">{{ (partner && partner.total)?numberWithCommas(partner.total):0}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 text-center" style="padding-top:22px;">
                        <a href="javascript:void(0)" @click="movePartnerToWallet()" class="text-white js-account-approve-aware btn" :style="checkStyle()" data-toggle="modal">
                          <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โอนเงินเข้ากระเป๋าหลัก</div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


<div data-loading-container=".modal-body" tabindex="-1" class="modal x-modal -promotion-detail-modal promotion-detail-modal-27 show" aria-modal="true" :style="`display: ${(showdetail)?`block`:'none'}; padding-right: 8px;`"><div class="modal-dialog -modal-size  " role="document" style="padding-top: 152.8px;max-width: 600px;">
    <div class="modal-content -modal-content" :style="{ 'background-image': `url(${require('../assets/images/Shiba-BG.jpg')})`}">
                    <button type="button" class="close f-1 " data-dismiss="modal" aria-label="Close" @click="closeDetail()">
                <i class="fas fa-times"></i>
            </button>
    <div class="modal-body -modal-body" style="top: 0px;">
        <div class="container">
            <div class="row">
                <div class="col-12 mt-4">
                    <div class="x-page-title-component ">
                      <div class="-inner-wrapper">
                        <h1 class="-title">{{titleDetail}}</h1>
                      </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-column">
          <div class="-real-content">
                    
            <div class="x-card card -card-promotion-detail ">
                                            
            <div style="padding-top:20px;">
                <font color="#fff">*ข้อมูลสรุปยอดเมื่อวาน</font>
                <div class="x-promotion-content">
                  <div class="fixTableHead">
                  <table class="tablecontainer">
                    <thead>
                      <tr>
                        <th><h1 style="text-align:center">รหัส</h1></th>
                        <th><h1 style="text-align:center">วันที่</h1></th>
                        <th><h1 style="text-align:center">ฝาก</h1></th>
                        <th><h1 style="text-align:center">ถอน</h1></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in history" :key="index">
                        <td style="text-align:center">{{item.friend}}</td>
                        <td style="text-align:center">{{item.createdateShow}}</td>
                        <td style="text-align:right">{{ numberWithCommas(item.deposit) }}</td>
                        <td style="text-align:right">{{ numberWithCommas(item.withdraw) }}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
            </div>

                            <div class="card-footer">
                    <!-- <button class="btn -btn -get-promotion-btn js-promotion-apply " data-toggle="modal" data-target="#depositModal" data-promotion-target="promotion-detail-modal-27" data-type="deposit" data-dismiss="modal" data-url="/promotion/27/apply">
                        <span>รับโปรโมชั่น</span>
                    </button> -->
                </div>
                        </div>
                </div>
                                    <div class="mx-3 mb-3">
                        <div class="x-admin-contact -no-fixed">
                            <span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
     <label class="-text-message ">ติดปัญหา&nbsp;</label>&nbsp;
     <a :href="lineLink" class="-link-message " target="_blank" rel="noopener">
        <u>ติดต่อฝ่ายบริการลูกค้า</u>
    </a>
</span>
                        </div>
                    </div>
                                    </div>
            </div>
    </div>
</div></div>

<footerSection></footerSection>
</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import moment from 'moment-timezone'
const axios = require('axios').default
export default {
  name: 'Partner',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue')
  },
  created () {
	  const user = localStorage.getItem('userData')
	  if (user) {
		  const _user = JSON.parse(user)
		  this.$store.dispatch('user/setUser', _user).catch(err => { console.error(err) })
	  } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/')
	  }
  },
  data: function () {
    return {
      level1:[],
      level2:[],
      partner: [],
      showdetail: false,
      titleDetail: '',
      history:[],
      mainMenu: 'partner',
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  computed: {
    lineAt () {
      return this.$store.state.settings?.lineAt || '@962mifra'
    },
    lineLink () {
      return this.$store.state.settings?.linkLine || 'https://page.line.me/962mifra'
    }
  },
  mounted () {
    this.scrollToTop()
    this.getPartner()
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    // Menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    movePartnerToWallet () {
      if (this.partner.total && this.partner.key) {
        this.$store.commit('user/SET_LOADING', true)
        axios.get(`https://phenix.apifast.xyz/qpartner/partner/${this.partner.key}`)
        setTimeout(() => {
          this.getPartner()
          this.$store.commit('user/SET_LOADING', false)
        }, 2000)
      }
    },
    clipboardSuccessHandler () {
      this.$swal({ icon: 'success', title: 'Copy', text: 'คัดลอกเรียบร้อยแล้ว' })
    },
    checkStyle () {
      if (this.partner && this.partner.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getPartner () {
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('partner').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.partner = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.partner = data
          })
        })
        firebase.firestore().collection('friends').where('userkey', '==', user.key).get().then((result) => {
          result.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            if(data.level === 1){
              this.level1.push(data)
            }else{
              this.level2.push(data)
            }
          })
        })
      }
    },
    async showlevel(level){
      const history = [];
      const deposit = [];
      const withdraw = [];
      if(level === 1){
        this.titleDetail = 'แนะนำเพื่อน';
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            deposit[doc.data().code] = doc.data().total;
          });
        });
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level1', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            withdraw[doc.data().code] = doc.data().total;
          });
        });
        if(this.level1){
          for(const x in this.level1){
            if(deposit[this.level1[x].friend]){
              this.level1[x].deposit = deposit[this.level1[x].friend];
            }else{
              this.level1[x].deposit = 0;
            }
            if(withdraw[this.level1[x].friend]){
              this.level1[x].withdraw = withdraw[this.level1[x].friend];
            }else{
              this.level1[x].withdraw = 0;
            }
            this.level1[x].createdateShow = moment().add(-1,'days').format('DD MMM,YY')
            history.push(this.level1[x]);
          }
        }
      }else{
        this.titleDetail = 'เพื่อนแนะนำเพื่อน';
        await firebase.firestore().collection('daily_deposit').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            deposit[doc.data().code] = doc.data().total;
          });
        });
        await firebase.firestore().collection('daily_withdraw').where('createdate', '==', moment().tz('Asia/Bangkok').add(-1,'days').format('YYYY-MM-DD')).where('level2', '==', this.user.code).get().then((snapshot) => {
          snapshot.forEach((doc)=>{
            withdraw[doc.data().code] = doc.data().total;
          });
        });
        if(this.level2){
          for(const x in this.level2){
            if(deposit[this.level2[x].friend]){
              this.level2[x].deposit = deposit[this.level2[x].friend];
            }else{
              this.level2[x].deposit = 0;
            }
            if(withdraw[this.level2[x].friend]){
              this.level2[x].withdraw = withdraw[this.level2[x].friend];
            }else{
              this.level2[x].withdraw = 0;
            }
            this.level2[x].createdateShow = moment().add(-1,'days').format('DD MMM,YY')
            history.push(this.level2[x]);
          }
        }
      }
      this.history = history;
      this.showdetail = true;
    },
    closeDetail(){
      this.showdetail = false;
    }
  }
}
</script>
<style scoped>
@media (max-width: 500px) {
    .x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-img-category {
        width: 45px;
        height: 45px;
    }
}
@media (max-width: 991.98px) {
.x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-menu-text .-menu-text-main {
    font-size: .8rem;
    font-weight: bold;
    font-family: 'Kanit';
    text-align: center;
    display: block;
    padding-top: 4px;
}
}
@media (min-width: 991.98px) {
.x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent .-menu-text .-menu-text-main {
    font-size: 16px;
    font-weight: bold;
    font-family: 'Kanit';
    text-align: center;
    display: block;
    padding-top: 4px;
}
}
@media (min-width: 991.98px) {
.x-category-index .-nav-menu-container .-menu-parent .-list-parent .-menu-btn.-parent {
    display: flex;
}
}
@media (max-width: 990px) {
#main_content_recommend .x-category-index, #main_content_income .x-category-index {
    padding-top: 10px;
}
}

h1 {
  font-size:3em;
  font-weight: 300;
  line-height:1em;
  text-align: center;
  color: #4DC3FA;
}

/* h2 {
  font-size:1em;
  font-weight: 300;
  text-align: center;
  display: block;
  line-height:1em;
  padding-bottom: 2em;
  color: #FB667A;
}

h2 a {
  font-weight: 700;
  text-transform: uppercase;
  color: #FB667A;
  text-decoration: none;
} */
.blue { color: #185875; }
.yellow { color: #FFF842; }

.tablecontainer th h1 {
  font-family: 'Kanit';
	  /* font-weight: bold; */
	  font-size: 1.1em;
    text-align: left;
    color: #fff;
}
.tablecontainer td {
  font-family: 'Kanit';
	  font-weight: normal;
	  font-size: 1em;
  -webkit-box-shadow: 0 2px 2px -2px #0E1119;
	   -moz-box-shadow: 0 2px 2px -2px #0E1119;
	        box-shadow: 0 2px 2px -2px #0E1119;
}

.tablecontainer {
  text-align: left;
  border-collapse: collapse;
  width: 100%;
  margin: 0 auto;
  display: table;
  padding: 0 0 8em 0;
}

.tablecontainer td, .tablecontainer th {
  padding-bottom: 2%;
  padding-top: 2%;
  padding-left:2%;
}

/* Background-color of the odd rows */
.tablecontainer tr:nth-child(odd) {
  background-color: #ccc;
}

/* Background-color of the even rows */
.tablecontainer tr:nth-child(even) {
  background-color: #fff;
}

.tablecontainer th {
  background-color: #20c1f8;
}

.tablecontainer tr:hover {
  background-color: #464A52;
  -webkit-box-shadow: 0 6px 6px -6px #0E1119;
  -moz-box-shadow: 0 6px 6px -6px #0E1119;
      box-shadow: 0 6px 6px -6px #0E1119;
}

.tablecontainer td:hover {
  background-color: #FFF842;
  color: #403E10;
  font-weight: bold;

  box-shadow: #7F7C21 -1px 1px, #7F7C21 -2px 2px, #7F7C21 -3px 3px, #7F7C21 -4px 4px, #7F7C21 -5px 5px, #7F7C21 -6px 6px;
  transform: translate3d(6px, -6px, 0);

  transition-delay: 0s;
	  transition-duration: 0.4s;
	  transition-property: all;
  transition-timing-function: line;
}
.fixTableHead {
      overflow-y: auto;
      height: 500px;
}
.fixTableHead thead th {
  position: sticky;
  top: 0;
}
.recommend_section input {
    border: 1px solid #fec33f;
    background: rgba(0,0,0,.5)!important;
    font-family: Kanit,sans-serif;
    color: #fff;
}
.btn_bg {
    background: linear-gradient(160deg,#b47e11,#fec33f,#e09c14);
    border-radius: 50px;
    border: none;
    padding: 6px;
}

/* Main Layout Styles */
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-image: url('../assets/images/Shiba-BG.jpg');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.desktop-layout {
  display: flex;
  flex: 1;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  padding: 20px 0;
}

.mobile-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.mobile-with-sidebar {
  display: flex;
  flex: 1;
}

.mobile-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.mobile-content-wrapper {
  flex: 1;
  padding: 20px 0;
}

/* Responsive classes */
@media (max-width: 991.98px) {
  .desktop-only {
    display: none !important;
  }
  .mobile-only {
    display: flex !important;
  }
}

@media (min-width: 992px) {
  .desktop-only {
    display: flex !important;
  }
  .mobile-only {
    display: none !important;
  }
}

/* Cover Section Styles */
.x-cover {
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  position: relative;
  overflow: hidden;
  height: 100px;
}

.mobile-cover {
  margin-top: 0;
}

.-contents-wrapper {
  min-height: 200px;
  align-items: center;
}

.-right-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  margin-bottom: 15px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.-sub-title {
  font-size: 1.2rem;
  color: rgba(255,255,255,0.9);
  margin-bottom: 20px;
}

@media (max-width: 767.98px) {
  .-title {
    font-size: 1.8rem;
  }
  .-sub-title {
    font-size: 1rem;
  }
}

</style>
